export default "__VITE_ASSET__CtZVf_$m__"